import { MutationTree } from "vuex"
import { Booking, BookingResource, BookingsFilter, BookingsState } from "~/store/bookings/bookings.types"
import Vue from "vue"
import { extractResourceIds, filterId } from "~/utils/store"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"

interface BookingsMutation {
  params: RequestParameters<Booking, BookingsFilter>
  data: BookingResource[]
}

const mutations: MutationTree<BookingsState> = {
  SET_BOOKING (state: BookingsState, booking: BookingResource) {
    const { id } = booking

    Vue.set(state.data, id, booking)
  },

  SET_BOOKINGS (state: BookingsState, { params, data }: BookingsMutation) {
    if (data && data.length <= 0) {
      return
    }

    data.forEach(resource => Vue.set(state.data, resource.id, resource))

    const id = filterId(params)

    Vue.set(state.filters, id, extractResourceIds(data))
  },

  DELETE_BOOKING (state: BookingsState, id: string) {
    Vue.delete(state.data, id)
  }
}

export default mutations
